import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  width: 900px;
  min-height: 200px;
  max-height: calc(100vh - 20%);
  overflow: scroll;
  background: #fff;
  border-radius: 10px;
  padding: 30px 40px;
  box-shadow: 0 0 20px 0 rgba(101, 101, 101, 0.5);
  z-index: 2;

  scrollbar-width: none;

  &::-webkit-scrollbar {
    width: 0;
    height: 0;
  }

  &::-webkit-scrollbar-track {
    -webkit-box-shadow: none;
    border-radius: 0;
  }

  &::-webkit-scrollbar-thumb {
    border: transparent 1px solid;
    background-color: transparent;
  }

  overflow: -moz-scrollbars-none;
`;

export default Container;
